import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TopNav from "./TopNav";

export default function CartComponent({ cart, products, shippingCostInfo, editable, handleChange, removeFromCart }) {
    const [useTrackTrace, setUseTrackTrace] = useState(() => {
        const saved = localStorage.getItem("useTrackTrace");
        return saved ? JSON.parse(saved) : false;
    });

    useEffect(() => {
        localStorage.setItem("useTrackTrace", JSON.stringify(useTrackTrace));
    }, [useTrackTrace]);

    const VAT_RATE = parseFloat(process.env.REACT_APP_VAT_RATE || "0");

    const hasDiscount = cart.some(item => {
        const product = products.find(p => p._id === item.productId);
        return product && product.hasActiveDiscount;
    });

    const totalExcludingShipping = cart.reduce((sum, item) => {
        const product = products.find(p => p._id === item.productId);
        return sum + product.price * item.quantity;
    }, 0);
    console.log(`totalExcludingShipping: ${totalExcludingShipping}`);
    const subTotalExcludingShipping = cart.reduce((sum, item) => {
        const product = products.find(p => p._id === item.productId);
        return sum + product.storedPrice * item.quantity;
    }, 0);

    const netTotalExcludingShipping = totalExcludingShipping / (1 + VAT_RATE);
    const netSubTotalExcludingShipping = subTotalExcludingShipping / (1 + VAT_RATE);


    const netExcludingShipping = totalExcludingShipping / (1 + VAT_RATE);
    let trackTraceCosts = 0;

    if (useTrackTrace && parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0) {
        trackTraceCosts = parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS);
    }

    const netTrackTraceCosts = trackTraceCosts / (1 + VAT_RATE);

    let total = totalExcludingShipping + trackTraceCosts;
    let subTotal = subTotalExcludingShipping + trackTraceCosts;
    let shippingCosts = 0;

    if (totalExcludingShipping < shippingCostInfo.threshold) {
        total += shippingCostInfo.costs;
        subTotal += shippingCostInfo.costs;
        shippingCosts = shippingCostInfo.costs;
    }

    const netShippingCosts = shippingCosts / (1 + VAT_RATE);
    const netTotal = total / (1 + VAT_RATE);
    const netSubTotal = subTotal / (1 + VAT_RATE);
    const vatTotal = total - netTotal;

    return (<>
        <div className="cart-table-container">
            <table className="cart-table">
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Size</th>
                        <th>Qty</th>
                        <th>&nbsp;</th>
                        <th>Unit price (net)</th>
                        {hasDiscount && <th>Discount</th>}
                        <th>Total</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {cart.map((item, idx) => {
                        const product = products.find(p => p._id == item.productId);
                        const netOrg = product.storedPrice / (1 + VAT_RATE);
                        const net = product.price * item.quantity / (1 + VAT_RATE);
                        const netDiscount = product.discount / (1 + VAT_RATE)

                        return (
                            <tr key={idx}>
                                <td>
                                    {product.images && product.mainImageId && (
                                        <img
                                            className="product-img"
                                            src={product.images.find(i => i._id === product.mainImageId)?.iconUrl}
                                            alt={product.images.find(i => i._id === product.mainImageId)?.altText || "MFK Venom premium goalkeepers glove"}
                                        />
                                    )}
                                    <span className="product-name">{product.name}</span>
                                </td>
                                <td>{item.size}</td>
                                <td>
                                    {editable && (
                                        <button className="qty-btn-round decrease"
                                            onClick={() => handleChange(item.productId, item.size, 'quantity', Math.max(1, (item.quantity || 1) - 1))}>
                                            <svg width="12" height="12" viewBox="0 0 12 12" stroke="white" strokeWidth="2">
                                                <line x1="2" y1="6" x2="10" y2="6" />
                                            </svg>
                                        </button>
                                    )}
                                    {item.quantity}
                                    {editable && (
                                        <button className="qty-btn-round increase"
                                            onClick={() => handleChange(item.productId, item.size, 'quantity', Math.min(9, (item.quantity || 1) + 1))}>
                                            <svg width="12" height="12" viewBox="0 0 12 12" stroke="white" strokeWidth="2">
                                                <line x1="6" y1="2" x2="6" y2="10" />
                                                <line x1="2" y1="6" x2="10" y2="6" />
                                            </svg>
                                        </button>
                                    )}
                                </td>
                                <td>
                                    {editable && (
                                        <button className="qty-btn-round" onClick={() => removeFromCart(item.productId, item.size)}>
                                            <svg width="12" height="12" viewBox="0 0 12 12" stroke="white" strokeWidth="2">
                                                <line x1="3" y1="3" x2="9" y2="9" />
                                                <line x1="9" y1="3" x2="3" y2="9" />
                                            </svg>
                                        </button>
                                    )}
                                </td>
                                <td>
                                    &euro;{netOrg.toFixed(2)}
                                </td>
                                {product.hasActiveDiscount && (
                                    <td>€{netDiscount.toFixed(2)}</td>
                                )}
                                <td>
                                    €{net.toFixed(2)}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td className="total" colSpan={7}></td>
                    </tr>
                    <tr>
                        <td>Subtotal:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        {hasDiscount ? (
                            <td>&euro;{netSubTotalExcludingShipping.toFixed(2)}</td>
                        ) : (
                            <td>&nbsp;</td>
                        )}
                        {hasDiscount && (
                            <td>&euro;{(netSubTotalExcludingShipping - netTotalExcludingShipping).toFixed(2)}</td>
                        )}
                        <td>&euro;{netExcludingShipping.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>Shipping<sup>*)</sup>:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        {hasDiscount && (<td>&nbsp;</td>)}
                        <td>&euro;{netShippingCosts.toFixed(2)}</td>
                    </tr>
                    {parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0 && (
                        <tr>
                            <td>Track & Trace<sup>**) </sup>:</td>
                            <td colSpan={3}>
                                <input
                                    type="checkbox"
                                    checked={useTrackTrace}
                                    onChange={(e) => setUseTrackTrace(e.target.checked)}
                                />
                                <label>Use track & trace</label>
                            </td>
                            <td>&nbsp;</td>
                            {hasDiscount && (<td>&nbsp;</td>)}
                            <td>&euro;{netTrackTraceCosts.toFixed(2)}</td>
                        </tr>
                    )}
                    <tr>
                        <td className="total" colSpan={7}></td>
                    </tr>
                    <tr>
                        <td>Net total:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        {hasDiscount && (<td>&nbsp;</td>)}
                        <td>&euro;{netTotal.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td>VAT:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        {hasDiscount && (<td>&nbsp;</td>)}
                        <td>&euro;{vatTotal.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td className="total" colSpan={7}></td>
                    </tr>
                    <tr>
                        <td>Total:</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        {hasDiscount && (<td>&nbsp;</td>)}
                        <td>&euro;{total.toFixed(2)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div className="cart-cards">
            {cart.map((item, idx) => {
                const product = products.find(p => p._id == item.productId);
                const netOrg = product.storedPrice / (1 + VAT_RATE);
                const net = product.price * item.quantity / (1 + VAT_RATE);
                const netDiscount = product.discount / (1 + VAT_RATE);
                return (
                    <div className="cart-card" key={idx}>
                        <div className="cart-card-header">
                            {product.images && product.mainImageId && (
                                <img
                                    className="product-img"
                                    src={product.images.find(i => i._id === product.mainImageId)?.iconUrl}
                                    alt={product.images.find(i => i._id === product.mainImageId)?.altText || "Product"}
                                />
                            )}
                            <span className="product-name">{product.name}</span>
                        </div>
                        <div>Size: {item.size}</div>
                        <div>Quantity: {item.quantity}</div>
                        {editable && (
                            <>
                                <div>
                                    <button className="qty-btn-round decrease"
                                        onClick={() => handleChange(item.productId, item.size, 'quantity', Math.max(1, (item.quantity || 1) - 1))}>-</button>
                                    <button className="qty-btn-round increase"
                                        onClick={() => handleChange(item.productId, item.size, 'quantity', Math.min(9, (item.quantity || 1) + 1))}>+</button>
                                    <button className="qty-btn-round" onClick={() => removeFromCart(item.productId, item.size)}>Remove</button>
                                </div>
                            </>
                        )}
                        <div>Unit price (net): €{netOrg.toFixed(2)}</div>
                        {product.hasActiveDiscount && (
                            <div>Discount: €{netDiscount.toFixed(2)}</div>
                        )}
                        <div>Total: €{net.toFixed(2)}</div>
                    </div>
                );
            })}
        </div>
        <div className="cart-summary-card">
            {hasDiscount && (
                <>
                    <hr />
                    <div className="summary-row"><span>Net subtotal (no discount):</span><span>€{netSubTotalExcludingShipping.toFixed(2)}</span></div>
                    <div className="summary-row"><span>Net discount:</span><span>€{(netSubTotalExcludingShipping - netTotalExcludingShipping).toFixed(2)}</span></div>
                </>
            )}
            <hr />
            <div className="summary-row"><span>Subtotal{hasDiscount && (" (with discount)")}:</span><span>€{netExcludingShipping.toFixed(2)}</span></div>
            <div className="summary-row"><span>Shipping<sup>*)</sup>:</span><span>€{netShippingCosts.toFixed(2)}</span></div>
            {parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0 && (
                <div className="summary-row">
                    <span>Track &amp; Trace<sup>**) </sup>:</span><span>€{netTrackTraceCosts.toFixed(2)}</span>
                </div>
            )}
            <hr />
            <div className="summary-row"><span>Net total:</span><span>€{netTotal.toFixed(2)}</span></div>
            <div className="summary-row"><span>VAT:</span><span>€{vatTotal.toFixed(2)}</span></div>
            <hr />
            <div className="summary-row total"><span>Total:</span><span>€{total.toFixed(2)}</span></div>
        </div>
        <p className="note">
            <sup>*)</sup> Orders under &euro;{shippingCostInfo.threshold.toFixed(2)} are subject {" "}
            to a shipping fee of &euro;{shippingCostInfo.costs.toFixed(2)}.
            {parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0 && (
                <>
                    <br />
                    <sup>**) </sup>Track & Trace costs are &euro;{parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS).toFixed(2)}.
                </>
            )}
        </p>
    </>);
}
